import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { base_url, meetspace_base_url } from "../../Componenets/base_url";

export const getAllEventsList = createAsyncThunk('all-events-list', async () => {
    const response = await axios.get(`${meetspace_base_url}/getAllEvents`);
    return response?.data?.result?.userslots;
})

